import { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TickButton } from '../svg';
import './MultiColorTextLabel.scss';
import { NoticeProps } from './NoticePopup';

type Prop = NoticeProps & { scaling: number };
export const NoticeTitle = (prop: Prop) => {
    const { id, scaling, haveTitle } = prop;
    const { t, i18n } = useTranslation();
    const [title, setTitle] = useState<ReactNode>();
    useEffect(() => {
        if (haveTitle) {
            if (id === 'notice_abc') {
                const tmpArr = t('abc.no_tick').split('(✔)');
                setTitle(
                    <>
                        <div className={`text-color-gold`}>
                            {t('abc.abc_is_on')}
                        </div>
                        <span className={`text-color-white`}>
                            {tmpArr[0]}
                            {<TickButton height={`${1.5 * scaling}rem`} />}
                            {tmpArr[1]}
                        </span>
                    </>
                );
            }
        }
    }, [id, i18n.language]);
    return title;
};

export const NoticeContent = (prop: Prop) => {
    const { id, imageLang } = prop;
    const { i18n } = useTranslation();
    const [image, setImage] = useState<ReactNode>();
    useEffect(() => {
        if (id === 'notice_abc') {
            const lang = imageLang.includes(i18n.language)
                ? i18n.language
                : 'en-US';

            setImage(
                <img
                    className="NoticeImage"
                    src={`${process.env.PUBLIC_URL}/resource/assets/image/notice/${lang}/notice_abc.jpg`}
                />
            );
        }
    }, [id, i18n.language, imageLang]);
    return image;
};
